const gifList = [
    {id: 1, url:  'https://arttice.com/arttice-logo/1_Tour.gif', action: 'create new page'},
    {id: 2, url: 'https://arttice.com/arttice-logo/2_Tour.gif', action: 'choose page category'},
    {id: 3, url:'https://arttice.com/arttice-logo/3_Tour.gif', action: 'choose page discipline(s)'},
    {id: 4, url:"https://arttice.com/arttice-logo/4_Tour.gif",  action: 'connect to facebook page(s) you manage'},
    {id: 5, url:'https://arttice.com/arttice-logo/5_Tour.gif', action: 'import data from facebook page'},
    {id: 6, url:'https://arttice.com/arttice-logo/6_Tour.gif', action: 'enter your location'},
    {id: 7, url:'https://arttice.com/arttice-logo/7_Tour.gif', action: 'invite to arttice over email'},
    {id: 8, url:'https://arttice.com/arttice-logo/8_Tour.gif', action: 'invite to arttice with a link'},
    {id: 9, url:'https://arttice.com/arttice-logo/9_Tour.png', action: 'toggle between pages and events'},
    {id: 10, url:'https://arttice.com/arttice-logo/10_Tour.png', action: 'edit your page'},
    {id: 11, url:'https://arttice.com/arttice-logo/11_Tour.png', action: 'create new page event'}
]

const mobileGifList = [
    {id: 1, url: 'https://arttice.com/arttice-logo/1_Tour_mob.gif', action: 'create new page'},
    {id: 2, url: 'https://arttice.com/arttice-logo/2_Tour_mob.gif', action: 'choose page category'},
    {id: 3, url:'https://arttice.com/arttice-logo/3_Tour_mob.gif', action: 'choose page discipline(s)'},
    {id: 4, url: "https://arttice.com/arttice-logo/4_Tour_mob.gif",  action: 'connect to facebook page(s) you manage'},
    {id: 5, url:'https://arttice.com/arttice-logo/5_Tour_mob.gif', action: 'import data from facebook page'},
    {id: 6, url:'https://arttice.com/arttice-logo/6_Tour_mob.gif', action: 'enter your location'},
    {id: 7, url:'https://arttice.com/arttice-logo/7_Tour_mob.gif', action: 'invite to arttice over email'},
    {id: 8, url:'https://arttice.com/arttice-logo/8_Tour_mob.gif', action: 'invite to arttice with a link'},
    {id: 9, url:'https://arttice.com/arttice-logo/9_Tour_mob.png', action: 'edit your page'},
    {id: 10, url:'https://arttice.com/arttice-logo/10_Tour_mob.png', action: 'create new page event'},
    {id: 11, url:'https://arttice.com/arttice-logo/11_Tour_mob.png', action: 'toggle between pages and events'},
]

export default {gifList, mobileGifList}